import { Head, Link, useForm } from "@inertiajs/react";
import { MapPin, ArrowRight } from "lucide-react";
import SchoolLayout from "@/components/schools/SchoolLayout";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export default function PickLocation({ school, membership, locations, submit_path }) {
  const { data, setData, patch, processing } = useForm({
    location_id: locations[0]?.id || "",
  });

  const submit = (e) => {
    e.preventDefault();
    patch(submit_path);
  };

  return (
    <SchoolLayout school={school} membership={membership} eyebrow="Setup" title="Pick a Square location">
      <Head title={`${school.name} · Pick location`} />

      <Card>
        <CardHeader>
          <div className="flex items-center gap-3">
            <div className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary">
              <MapPin className="h-5 w-5" />
            </div>
            <div>
              <CardTitle>Which location receives donations?</CardTitle>
              <CardDescription className="mt-1">
                Donations will be credited to the Square location you pick. You can change this later.
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          {locations.length === 0 ? (
            <p className="text-sm text-muted-foreground">
              Your Square account has no active locations. Add one in your Square dashboard, then refresh this page.
            </p>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                {locations.map((loc) => (
                  <label key={loc.id}
                         className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer hover:bg-secondary/20 ${
                           data.location_id === loc.id ? "border-primary bg-primary/5" : "border-border"
                         }`}>
                    <input
                      type="radio"
                      name="location_id"
                      value={loc.id}
                      checked={data.location_id === loc.id}
                      onChange={() => setData("location_id", loc.id)}
                    />
                    <div className="flex-1">
                      <div className="font-medium text-foreground">{loc.name}</div>
                      <div className="text-xs text-muted-foreground font-mono">{loc.id}</div>
                    </div>
                  </label>
                ))}
              </div>

              <div className="flex gap-3 pt-3 border-t border-border">
                <Button type="submit" disabled={processing || !data.location_id}>
                  {processing ? "Saving…" : "Finish setup"}
                  <ArrowRight className="h-4 w-4" />
                </Button>
                <Button variant="outline" asChild>
                  <Link href={school.dashboard_path}>Cancel</Link>
                </Button>
              </div>
            </form>
          )}
        </CardContent>
      </Card>
    </SchoolLayout>
  );
}
